import WaitlistCta from './WaitlistCta';
import styles from './ProblemSection.module.css';

export default function ProblemSection({ onOpenWaitlist }) {
  return (
    <section className={styles.section}>
      <div className={styles.border}>
        <div className={styles.header}>
          <span className={styles.index}>[ 01 ]</span>
          <h2 className={styles.title}>The Stack Is Broken</h2>
        </div>

        <div className={styles.body}>
          <p className={styles.lede}>
            AI agents are writing code at a pace no engineering organisation has
            ever seen. Hundreds of commits per hour. Thousands of lines changed
            per day. Pull requests that arrive faster than any team can review
            them.
          </p>

          <p className={styles.text}>
            The tools we depend on weren't built for this. Git platforms that
            buckle under monorepo scale. Code review workflows that assume a
            human is reading every diff. CI systems that cold-start containers
            on every push and collapse under volume. Release pipelines gated on
            manual approvals. Observability platforms that charge by the
            gigabyte while teams drown in noise.
          </p>

          <p className={styles.text}>
            The entire stack — from source control to production alerting — was
            architected for a world where developers were the bottleneck. That
            world is ending. The new bottleneck is the infrastructure around the
            code.
          </p>

          <div className={styles.cta}>
            <WaitlistCta onOpen={onOpenWaitlist} />
          </div>
        </div>
      </div>
    </section>
  );
}
